module.exports = __webpack_public_path__ + "media/images/area/feature/chugoku/related/zh-hans/4-fabfe52fa1847c15374361b2df0251a6.jpg";